import { ValidationMark } from '../../components/ValidationMark';
import { t } from '../../services/translation/translation';

type Props = {
  value: string;
};

export const ValidationStatus = ({ value }: Props) => {
  const hasMinSize = value.length >= 8;
  const hasDigit = /[0-9]/.test(value);
  const hasUppercase = /[A-Z]/.test(value);
  const hasLowercase = /[a-z]/.test(value);

  return (
    <div className="space-y-2 px-2">
      <div className="flex items-center">
        <ValidationMark isValid={hasMinSize} />
        <p className="text-sm ml-2">{t('sign-up-route.tip-length')}</p>
      </div>
      <div className="flex items-center">
        <ValidationMark isValid={hasDigit} />
        <p className="text-sm ml-2">{t('sign-up-route.tip-digit')}</p>
      </div>
      <div className="flex items-center">
        <ValidationMark isValid={hasUppercase} />
        <p className="text-sm ml-2">{t('sign-up-route.tip-uppercase')}</p>
      </div>
      <div className="flex items-center">
        <ValidationMark isValid={hasLowercase} />
        <p className="text-sm ml-2">{t('sign-up-route.tip-lowercase')}</p>
      </div>
    </div>
  );
};
